exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-alert--material{margin-top:32px}.v-alert--material .v-alert__icon{top:-36px}.v-alert--material .v-alert__dismissible{-ms-flex-item-align:start;align-self:flex-start;margin:0!important;padding:0!important}", ""]);

// exports
